import SimpleCrypto from 'simple-crypto-js'

const simpleCrypto = new SimpleCrypto(process.env.VUE_APP_CRYPTO)

export const obtainUserPermissions = {
  arrayPermissionsFromLocalStorage() {
    const arrayPermissionsJSON = localStorage.getItem('pcm_permissions')
    return simpleCrypto.decrypt(arrayPermissionsJSON)
  },
}
